<div class="outer-container">
  <mat-card>
    <mat-card-title class="grid-item-title">{{ 'dataManagement.gs1DataTransfer.title' | transloco }}</mat-card-title>
    <mat-card-content>
      <mat-tab-group class="mat-tab-fill-height export-list-group">
        <mat-tab label="{{ 'dataManagement.gs1DataTransfer.titleSystems' | transloco }}">
          <div class="tab-content">
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title><h5>{{ 'dataManagement.gs1DataTransfer.requiresReview' | transloco }}</h5></mat-panel-title>
                </mat-expansion-panel-header>

                <app-packaging-systems-overview #packagingSystemsRequiringReviewTable [dataSource]="packagingSystemsRequiringReviewDataSource" [allTags]="allTags"
                  [displayedColumns]="displayedColumnsRequiresReview" (infoButtonClick)="showPackagingSystemProblemInformation($event)">
                </app-packaging-systems-overview>
              </mat-expansion-panel>

              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title><h5>{{ 'dataManagement.gs1DataTransfer.readyForTransfer' | transloco }}</h5></mat-panel-title>
                </mat-expansion-panel-header>

                <app-packaging-systems-overview #packagingSystemsReadyForTransferTable [dataSource]="packagingSystemsReadyForTransferDataSource" [allTags]="allTags"
                  [displayedColumns]="displayedColumnsReadyForTransfer" (packagingPartsSelected)="isPackagingSystemReadyForTransferSelected = $event.length > 0">
                </app-packaging-systems-overview>

                <div class="transfer-button-container">
                  <button (click)="onTransferPackagingSystems()" [disabled]="!isPackagingSystemReadyForTransferSelected" mat-raised-button color="primary" class="transfer-button">{{ 'dataManagement.gs1DataTransfer.transferButton' | transloco }}</button>
                </div>
              </mat-expansion-panel>

              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title><h5>{{ 'dataManagement.gs1DataTransfer.transferred' | transloco }}</h5></mat-panel-title>
                </mat-expansion-panel-header>

                <app-packaging-systems-overview #packagingSystemsTransferredTable [dataSource]="packagingSystemsTransferredDataSource" [allTags]="allTags"
                  [displayedColumns]="displayedColumnsTransferred" (packagingPartsSelected)="isPackagingSystemTransferredSelected = $event.length > 0">
                </app-packaging-systems-overview>

                <div class="transfer-button-container">
                  <button (click)="onRetransferPackagingSystems()" [disabled]="!isPackagingSystemTransferredSelected" mat-raised-button color="primary" class="transfer-button">{{ 'dataManagement.gs1DataTransfer.retransferButton' | transloco }}</button>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </mat-tab>

        <mat-tab label="{{ 'dataManagement.gs1DataTransfer.titleUnits' | transloco }}">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title><h5>{{ 'dataManagement.gs1DataTransfer.requiresReview' | transloco }}</h5></mat-panel-title>
              </mat-expansion-panel-header>

              <app-packaging-units-overview #packagingUnitsRequiringReviewTable [dataSource]="packagingUnitsRequiringReviewDataSource" [allTags]="allTags"
                [displayedColumns]="displayedColumnsRequiresReview" (infoButtonClick)="showPackagingUnitProblemInformation($event)">
              </app-packaging-units-overview>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title><h5>{{ 'dataManagement.gs1DataTransfer.readyForTransfer' | transloco }}</h5></mat-panel-title>
              </mat-expansion-panel-header>

              <app-packaging-units-overview #packagingUnitsReadyForTransferTable [dataSource]="packagingUnitsReadyForTransferDataSource" [allTags]="allTags"
                [displayedColumns]="displayedColumnsReadyForTransfer" (packagingPartsSelected)="isPackagingUnitReadyForTransferSelected = $event.length > 0">
              </app-packaging-units-overview>

              <div class="transfer-button-container">
                <button (click)="onTransferPackagingUnits()" [disabled]="!isPackagingUnitReadyForTransferSelected" mat-raised-button color="primary" class="transfer-button">{{ 'dataManagement.gs1DataTransfer.transferButton' | transloco }}</button>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title><h5>{{ 'dataManagement.gs1DataTransfer.transferred' | transloco }}</h5></mat-panel-title>
              </mat-expansion-panel-header>

              <app-packaging-units-overview #packagingUnitsTransferredTable [dataSource]="packagingUnitsTransferredDataSource" [allTags]="allTags"
                [displayedColumns]="displayedColumnsTransferred" (packagingPartsSelected)="isPackagingUnitTransferredSelected = $event.length > 0" >
              </app-packaging-units-overview>

              <div class="transfer-button-container">
                <button (click)="onRetransferPackagingUnits()" [disabled]="!isPackagingUnitTransferredSelected" mat-raised-button color="primary" class="transfer-button">{{ 'dataManagement.gs1DataTransfer.retransferButton' | transloco }}</button>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>
